<template lang="pug">
#modal-reanalise-certificacao
    el-dialog(
        title='Acompanhar Solicitação de Laudo',
        width='500px',
        top='5vh',
        :visible='show',
        @close='closeDialog'
    )
        p
            b SLA Solicitação de Laudo
        hr
        p
            b Território:
            |
            | {{ rowInfo.geometrias[0].nomeTerritorio }}
        p
            b Localidade:
            |
            | {{ rowInfo.geometrias[0].municipioTerritorioNome }} / {{ rowInfo.geometrias[0].estadoTerritorioSigla }}
        p.margin-p
            b CAR(s) vinculado(s):
            ul.lista-car
                li.lista(v-for='car in rowInfo.cars')
                    span {{ car.codigo }}
        hr
        p
            b Laudo solicitado em:
            |
            | {{ rowInfo.dataSolicitacaoLaudo }}

        .d-flex.flex-direction.justify-content-between.py-3
            el-button(slot='footer', size='mini', @click='closeDialog') Voltar
</template>

<script>
import BlocoListarAtivasCertificao from '@/components/certificacao/BlocoListarAtivasCertificao.vue';

export default {
    name: 'ModalAcompanharSolicitacaoLaudo',
    components: {
        BlocoListarAtivasCertificao
    },
    emits: ['update:show'],
    props: {
        show: {
            type: Boolean,
            required: true
        },
        rowInfo: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            certificacao: {
                idsTerritorio: [],
                idsCertificacaoTipo: []
            }
        };
    },

    methods: {
        closeDialog() {
            this.clearFields();
            this.$emit('update:show', false);
        },
        idsCertificacaoTipo(idsCertificacaoTipo) {
            this.certificacao.idsCertificacaoTipo = idsCertificacaoTipo.idsTipo;
        },
        clearFields() {
            this.certificacao.idsTerritorio = [];
        },
        atualizarTabela() {
            this.$emit('atualizarTabela');
        }
    }
};
</script>

<style lang="scss">
.el-dialog__header {
    padding: 20px;
    padding-bottom: 10px;
    background: #f6f6f6;
    color: #3b3b3b;
    padding-bottom: 12px;
    padding-top: 12px;
}
.el-dialog__body {
    padding: 20px 20px 30px 20px;
    word-break: break-word;
}
.el-dialog__headerbtn {
    top: 10px;
}
.el-dialog__headerbtn:hover .el-icon-close {
    color: #ffffff;
}

.el-dialog__title {
    color: var(--primary);
    font-weight: bold;
}
</style>
